import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import LayoutGuest from '../../components/layouts/LayoutGuest';
import ServiceSlide from './ServiceSlide';
import PromoSlide from './PromoSlide';
import ClientRunning from './ClientRunning';
import TestiSection from './TestiSection';
import { TourSlider } from '../ServiceView/component/TourSlider';
import Link from '../../components/ui/Link';
import { DETAILSERVICE_PAGE_NOID } from '../../routes/routeConstant';
import useAssetStore from '../../stores/useAssetStore';

export default function Home() {
  const { t } = useTranslation();
  const { assets } = useAssetStore();

  return (
    <LayoutGuest>
      <header
        style={{ backgroundImage: `url(${assets.landingImage})` }}
        className="transition-all w-full duration-700 flex bg-cover bg-top bg-fixed justify-center items-center gap-3 flex-col md:h-[60vh] h-[300px] bg-blue-50 overflow-hidden"
      >
        <div className="flex w-full h-full justify-center items-center p-4 bg-gradient-to-r from-primary to-transparent gap-3 flex-col">
          <h1 className="text-white uppercase font-raleway md:text-3xl text-2xl font-bold animate-fade-in-down drop-shadow-md text-center">
            MSA Travel Services
          </h1>
          <h4 className="md:text-2xl font-redHatDisplay italic drop-shadow-md text-xl text-center font-bold bg-gradient-to-r from-neutral-50 to-currency bg-clip-text text-transparent animate-fade-in-up">
            {t('tagline.home.header')}
          </h4>
          <Link to={DETAILSERVICE_PAGE_NOID}>
            <Button variant="secondaryBackground" className="md:text-md w-fit text-sm" type="button">
              {t('tagline.home.button')}
            </Button>
          </Link>
        </div>
      </header>
      <section className="flex flex-col min-h-screen gap-4 max-w-screen-xl w-full mx-auto px-2">
        <div key="service" className="animate-fade-in-up duration-300">
          <ServiceSlide />
        </div>
        <div key="tour" className="animate-fade-in-up duration-500">
          <TourSlider />
        </div>
        <div key="promo" className="animate-fade-in-up duration-700">
          <PromoSlide />
        </div>
        <ClientRunning />
        <div key="testi" className="animate-fade-in-up duration-1000">
          <TestiSection />
        </div>
      </section>
    </LayoutGuest>
  );
}
